import React from "react";
import { useState } from "react";
import { Card, message, Tabs, Typography } from "antd";
import { Button, Form, Input, Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Title from "antd/lib/skeleton/Title";
import OTPInput from "otp-input-react";
import Post from "../services/Post";

const Security = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPinModalOpen, setIsPinModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("user-password");
  const [newPassword, setNewPassword] = useState();
  const [otpId, setOtpId] = useState();
  const [OTP, setOTP] = useState();

  const user = JSON.parse(localStorage.getItem("user"));

  const onChange = (key) => {
    console.log(key);
    setSelectedTab(key);
  };

  const onFinish = async (values) => {
    const data = {
      tab: selectedTab,
      type: "password",
      old_password: values.old_password,
      new_password: values.new_password,
    };

    const res = await Post.UpdatePassword(data);
    console.log(res.data);
    if (res.error) {
      message.error(res.error);
    } else {
      message.success(res.data);
      setIsModalOpen(false);
      setIsPinModalOpen(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const showModal = async () => {
    const res = await Post.UpdateSendOTP();
    if (res.error) {
      message.error("Something went wrong!");
    } else {
      setOtpId(res.id);
      if (selectedTab == "user-password") {
        setIsModalOpen(true);
      } else {
        setIsPinModalOpen(true);
      }
    }
  };
  const handleOk = async () => {
    // if (newPassword == null) {
    //   message.error('Please enter password');
    // }
    const data = {
      tab: selectedTab,
      type: "otp",
      id: otpId,
      value: OTP,
      new_password: newPassword,
    };
    const res = await Post.UpdatePassword(data);
    if (res.error) {
      message.error(res.error);
    } else {
      message.success(res.data);
      setIsModalOpen(false);
      setIsPinModalOpen(false);
      const oldUser = JSON.parse(localStorage.getItem("user")) || {};
      const updatedUser = { ...oldUser, ...res.user }; // merge new fields over old

      localStorage.setItem("user", JSON.stringify(updatedUser));
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsPinModalOpen(false);
  };

  return (
    <>
      <Card className="password_tabs">
        <Tabs
          onChange={onChange}
          type="card"
          items={[
            {
              label: "Profile Password",
              key: "user-password",
              children: (
                <div className="security_from">
                  <Card>
                    <Form
                      name="basic"
                      initialValues={{ remember: true }}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      autoComplete="off"
                    >
                      {user.isPasswordSet ? (
                        <>
                          <Form.Item
                            label="Old Password"
                            name="old_password"
                            rules={[
                              {
                                required: true,
                                message: "Please input your Old Password!",
                              },
                            ]}
                          >
                            <Input.Password className="input_field" />
                          </Form.Item>
                          <Form.Item
                            label={
                              user.isPasswordSet
                                ? "New Password"
                                : "Create Password"
                            }
                            name="new_password"
                            rules={[
                              {
                                required: true,
                                message: "Please input your New password!",
                              },
                            ]}
                          >
                            <Input.Password className="input_field" />
                          </Form.Item>

                          <div onClick={showModal} className="forget_btn">
                            {" "}
                            Forgot Password&emsp;
                            <QuestionCircleOutlined />
                          </div>
                        </>
                      ) : (
                        <Typography.Title level={4}>
                          Create Your Password
                        </Typography.Title>
                      )}

                      <Form.Item
                        className="form__main"
                        name="remember"
                        valuePropName="checked"
                        label={null}
                      >
                        <Modal
                          title={`${
                            user.isPasswordSet ? "Forgot" : "Create"
                          } Password`}
                          open={isModalOpen}
                          onOk={handleOk}
                          onCancel={handleCancel}
                        >
                          <label>Create Password</label>
                          <Input.Password
                            className="input_field"
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          <Title className="font-regular text-muted" level={5}>
                            Enter 6 digits OTP sent to your phone number
                          </Title>
                          <div className="otp-form">
                            <label>Enter OTP</label>
                            <OTPInput
                              className="otp__box"
                              value={OTP}
                              onChange={setOTP}
                              autoFocus
                              OTPLength={6}
                              otpType="number"
                              disabled={false}
                              secure
                              style={{ marginBottom: 20, padding: 10 }}
                            />
                          </div>
                        </Modal>
                      </Form.Item>

                      <Form.Item label={null}>
                        {user.isPasswordSet ? (
                          <Button
                            className="form-btn"
                            type="primary"
                            htmlType="submit"
                            style={{
                              width: "100%",
                              backgroundColor: "#a6cc43",
                              borderColor: "#a6cc43",
                            }}
                          >
                            Submit
                          </Button>
                        ) : (
                          <Button
                            className="form-btn"
                            type="primary"
                            onClick={showModal}
                            style={{
                              width: "100%",
                              backgroundColor: "#a6cc43",
                              borderColor: "#a6cc43",
                            }}
                          >
                            Create Password
                          </Button>
                        )}
                      </Form.Item>
                    </Form>
                  </Card>
                </div>
              ),
            },
            {
              label: "Transaction Pin",
              key: "transaction-pin",
              children: (
                <div className="security_from">
                  <Card>
                    <Form
                      name="basic"
                      initialValues={{ remember: true }}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      autoComplete="off"
                    >
                      {user.isPinSet ? (
                        <>
                          <Form.Item
                            label="Old Pin"
                            name="old_password"
                            rules={[
                              {
                                required: true,
                                message: "Please input your Old Pin!",
                              },
                            ]}
                          >
                            <Input.Password className="input_field" />
                          </Form.Item>

                          <Form.Item
                            label={user.isPinSet ? "New Pin" : "Create Pin"}
                            name="new_password"
                            rules={[
                              {
                                required: true,
                                message: "Please input your New Pin!",
                              },
                            ]}
                          >
                            <Input.Password className="input_field" />
                          </Form.Item>

                          <div onClick={showModal} className="forget_btn">
                            Forgot Transaction Pin&emsp;
                            <QuestionCircleOutlined />
                          </div>
                        </>
                      ) : (
                        <Typography.Title level={4}>
                          Create Your Pin
                        </Typography.Title>
                      )}
                      <Form.Item
                        className="form__main"
                        name="remember"
                        valuePropName="checked"
                        label={null}
                      >
                        {/* <Button type="primary" className="forget_btn form-btn" onClick={showModal}>
                        {" "}
                        
                      </Button> */}
                        <Modal
                          title={`${
                            user.isPinSet ? "Forgot" : "Create"
                          } Password`}
                          open={isPinModalOpen}
                          onOk={handleOk}
                          onCancel={handleCancel}
                        >
                          <Form.Item
                            label="Create Transaction Pin"
                            name="new_password"
                            rules={[
                              {
                                required: true,
                                message: "Please input your New pin!",
                              },
                            ]}
                          >
                            <Input.Password
                              className="input_field"
                              onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <Title
                              className="font-regular text-muted"
                              level={5}
                            >
                              Enter 6 digits OTP sent to your phone number
                            </Title>
                            <div className="otp-form">
                              <label>Enter OTP</label>
                              <OTPInput
                                value={OTP}
                                onChange={setOTP}
                                autoFocus
                                OTPLength={6}
                                otpType="number"
                                disabled={false}
                                secure
                                style={{ marginBottom: 20, padding: 10 }}
                              />
                            </div>
                          </Form.Item>
                        </Modal>
                      </Form.Item>

                      <Form.Item label={null}>
                        {user.isPinSet ? (
                          <Button
                            className="form-btn"
                            type="primary"
                            htmlType="submit"
                            style={{
                              width: "100%",
                              backgroundColor: "#a6cc43",
                              borderColor: "#a6cc43",
                            }}
                          >
                            Submit
                          </Button>
                        ) : (
                          <Button
                            className="form-btn"
                            type="primary"
                            onClick={showModal}
                            style={{
                              width: "100%",
                              backgroundColor: "#a6cc43",
                              borderColor: "#a6cc43",
                            }}
                          >
                            Create Pin
                          </Button>
                        )}
                      </Form.Item>
                    </Form>
                  </Card>
                </div>
              ),
            },
          ]}
        />
      </Card>
    </>
  );
};

export default Security;
